import React from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import clsx from 'clsx'

interface RadioSelectProps {
    id: string
    onClick: () => void
    size?: 'normal' | 'small'
    checked?: boolean
    disabled?: boolean
    ariaLabel?: string
    className?: string
}

const RadioSelect = (props: RadioSelectProps) => {
    const { id, onClick, size = 'normal', checked = false, disabled, ariaLabel, className } = props

    const handleSelect = (e: React.SyntheticEvent) => {
        e.preventDefault()
        e.stopPropagation()
        if (disabled || checked) {
            return
        }
        onClick()
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            handleSelect(e)
        }
    }

    return (
        <div
            className={clsx(
                'radio-select-component',
                `radio-select-${size}`,
                checked && 'checked',
                disabled && 'disabled',
                className
            )}
            role="radio"
            aria-checked={checked}
            aria-disabled={!!disabled}
            aria-label={ariaLabel}
            data-testid={'radio-select-component-' + id}
            tabIndex={disabled ? -1 : 0}
            onKeyDown={handleKeyDown}
            onClick={handleSelect}
        >
            <span className="radio-select-dot" />
        </div>
    )
}

export default observer(RadioSelect)
